/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Divider,
  Stack,
  Tooltip
} from "@mui/material";
import { useState, useEffect } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateRoleAccessHelper,
} from "../../helper/EmployeeHelper";
import { GetEmployeesAction } from "../../../../../store/Employee/Employee/Action";
import { checkPayrollAccess, getUserData } from "../../../Base/helper/baseFunctions";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { GetWorkLocationAction } from "../../../../../store/Ancillary/WorkLocation/Action";
import SelectableMultiSelect from "../../../Base/views/SelectableMultiSelect";

export default function RoleandAccess({
  setCurrentMode,
  currentMode,
  disableEdit,
  OnboardingEmpData,

}) {
   const userData = getUserData();
  const dispatch = useDispatch();
  const useStyles = makeStyles((theme) =>
    createStyles({
      paper: {
        boxShadow:
          theme.palette.mode === "dark"
            ? "rgb(0 0 0 / 20%) 0px 0px 2px 0px, rgb(0 0 0 / 12%) 0px 12px 24px -4px"
            : "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "20px",
        borderRadius: "10px",
      },
    })
  );
  const classes = useStyles();
  const initialValues = {
    name: "",
    core_hr_user_type: "",
    personal_mobile: "",
    office_email: "",
    enable_corehr: true,
    enable_ats: false,
    enable_payroll: false,
    enable_payroll_executive: false,
    enable_finance_executive: false,
    enable_visitor_management: false,
    vm_exec_access: false,
    enable_expense_executive: false,
    enable_lms_executive: false,
    all_locations_access: false,
    ats_work_location_id: [],
    enable_geofencing: true,
    enable_face_location_restriction: false,
    enable_settings_access: false,
    enable_employee_management: false,
    enable_lms: false
  };
  const [roleData, setRoleData] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const { workLocation_options } = useSelector(
    (state) => state?.AncillaryReducer?.WorkLocationReducer
  );
  const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
  const leaveAccess = atsModuleData?.find((item) => item.module_name === "Leave");
  
  const [worklocationData, setWorklocationData] = useState({
    load: false,
    values: [],
  });
  const handleWorkLoacation = () => {
    workLocation_options && setWorklocationData({
                      load: false,
                      values: workLocation_options,
                    })
  }
  useEffect(() => {
    if (currentMode === "edit" && OnboardingEmpData) {
      setRoleData({...OnboardingEmpData,
        ats_work_location_id: OnboardingEmpData?.work_location_json || []
      });
    } 
    dispatch(GetWorkLocationAction());
  }, []);
  const validate = (fieldValues) => {
    let temp = { ...errors };
    if ("user_type" in fieldValues) {
      temp.user_type =
        fieldValues.user_type === "" ? "User Type is required" : "";
    }
    if ("enable_payroll" in fieldValues) {
      temp.enable_payroll = fieldValues.enable_payroll &&
      !roleData?.enable_payroll_executive &&
      !roleData?.enable_finance_executive
        ? "Please select at least one executive type"
        : "";;
    }
    if (fieldValues?.all_locations_access && "ats_work_location_id" in fieldValues) {
        temp.ats_work_location_id =
        fieldValues.ats_work_location_id?.length === 0 ? "At least one work location access is required" : "";
    }
    setErrors({
      ...temp,
    });
    const temp1 = { ...temp };
    return Object.values(temp1).every((x) => x === "");
  };
  const handleInputChange = (event, value) => {
    if (event?.target?.name === "core_hr_user_type") { 
      setRoleData({ ...roleData, [event?.target?.name]: event?.target?.value,
        enable_expense_executive: event?.target?.value === "Admin" ? true : false,
        enable_settings_access: event?.target?.value === "Admin" ? true : false,
        enable_employee_management: event?.target?.value === "Admin" ? true : false,
        enable_lms: event?.target?.value === "Admin" ? true : false,
        enable_lms_executive: false,
        enable_payroll: false,
        enable_payroll_executive: false,
        enable_finance_executive: false,
        all_locations_access: false,
        ats_work_location_id: [],
        enable_face_location_restriction: false,
        vm_exec_access: false,

       });
    } else if (["enable_ats", "enable_visitor_management", 
          "enable_expense_executive", "enable_lms_executive", "enable_face_location_restriction", "enable_geofencing",
          "enable_settings_access", "enable_employee_management", "enable_lms","vm_exec_access"
        ].includes(event?.target?.name)) {
          const isLMS = event?.target?.name === "enable_lms";
          const isVisitorMg = event?.target?.name === "enable_visitor_management"
      setRoleData({ ...roleData, [event.target.name]: event.target.checked,
        ...(isLMS && {enable_lms_executive: false, enable_face_location_restriction: false}),
        ...(isVisitorMg && {vm_exec_access: false}),
       });
    }else if (["enable_payroll"].includes(event?.target?.name)) {
      setRoleData({ ...roleData, [event.target.name]: event.target.checked,
                    enable_payroll_executive: false,
                    enable_finance_executive: false,
       });
       if (errors?.enable_payroll) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          enable_payroll: "",
        }));
      }
    } else if (["all_locations_access"].includes(event?.target?.name)) {
      setRoleData({ ...roleData, [event.target.name]: event.target.checked,
                    ats_work_location_id: ["Admin"].includes(roleData?.core_hr_user_type) ? workLocation_options : [],
                    enable_face_location_restriction: false,
       });
       if (errors?.ats_work_location_id) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          ats_work_location_id: "",
        }));
      }
    } else if (["enable_payroll_executive","enable_finance_executive"].includes(event?.target?.name)) {
      setRoleData({ ...roleData, [event.target.name]: event.target.checked });
      if (errors?.enable_payroll) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          enable_payroll: "",
        }));
      }
    } else if (["ats_work_location_id"].includes(event)) {
        if (value) {
            setRoleData({ ...roleData, [event]: value });
        } else {
            setRoleData({ ...roleData, [event]: "" });
        }
        Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
            validate({ ...roleData, [event]: value ? value : "" });
      } else {
        setRoleData({ ...roleData, [event.target.name]: event.target.value });
        Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
          validate({ ...roleData, [event.target.name]: event.target.value });
    }
  };
  const handleSubmit = () => {
    if (validate(roleData)) {
        if (roleData?.emp_users || roleData?.emp_users_pk) {
         const locationPayload = JSON.stringify((roleData?.ats_work_location_id || [])?.map((item) => ({ ...item })));
          UpdateRoleAccessHelper({ ...roleData, 
            ats_work_location_id: (roleData?.ats_work_location_id || [])?.length > 0 ? locationPayload : null
          }).then((res) => {
            if(res?.data?.statuscode === 200) {
              dispatch(GetEmployeesAction({ is_active: true }));
              setCurrentMode("grid");
            }
          });
        } 
    }
  };
  const handleBack = () => {
    setCurrentMode("grid");
  }
  const isOwner = ["Owner"].includes(roleData?.core_hr_user_type)
  return (
        <Box sx={{ width: "100%", padding: "0px 30px 20px 30px" }}>
            
              <Grid
                container
                sx={{
                  display: "flex",
                  justifyContent:
                    roleData?.core_hr_user_type === "Owner"
                      ? "flex-end"
                      : "space-between",
                  alignItems: "center",
                  marginRight: "10px",
                  marginTop: "10px",
                  position: "sticky",
                  top: 0,
                  zIndex: 2,
                  bgcolor: "#ffffff",
                  p: 1
                }}
              >
                <Button
                  sx={{ marginRight: "10px" }}
                  type="submit"
                  variant="contained"
                  size="medium"
                  className="mpl-primary-btn"
                  onClick={handleBack}
                >
                  Back
                </Button>
             
                <Typography
                  sx={{
                    flexGrow: 1,
                    textAlign: currentMode !== undefined ? "center" : "center",
                  }}
                  variant="h6"
                >
                  Role & Access
                </Typography>

                {roleData?.core_hr_user_type !== "Owner" &&
                  (roleData?.emp_users || roleData?.emp_users_pk) && (
                    <>
                      <Button
                        variant="contained"
                        size="medium"
                        onClick={() => handleSubmit()}
                        className="mpl-primary-btn"
                      >
                        {"Update user"}
                      </Button>
                    </>
                  )}
              </Grid>
            
            <Grid item xs={12} md={12} sx={{ marginTop: "1.5rem" }}>
              <Paper className={classes.paper}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Details
                    </Typography>
                  </Grid>
                  {isOwner ? (
                    <Grid item xs={12} sm={6} md={4}>
                      <FormControl fullWidth>
                        <TextField
                          disabled
                          label="User Type"
                          name="core_hr_user_type"
                          onChange={handleInputChange}
                          value={roleData?.core_hr_user_type}
                          size="small"
                        />
                      </FormControl>
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={6} md={4}>
                      <FormControl
                        required
                        fullWidth
                        error={errors?.core_hr_user_type ? true : false}
                        size="small"
                      >
                        <InputLabel id="recruiter-type-select-label">
                          User Type
                        </InputLabel>
                        <Select
                          name="core_hr_user_type"
                          labelId="recruiter-type-select-label"
                          id="recruiter-type-select"
                          value={roleData?.core_hr_user_type}
                          label="User Type"
                          onChange={handleInputChange}
                        >
                          <MenuItem value={"Admin"}>Admin</MenuItem>
                          <MenuItem value={"Employee"}>Employee</MenuItem>
                        </Select>
                        <FormHelperText>
                          {errors?.core_hr_user_type}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                  )}

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <TextField
                        disabled
                        label="Name"
                        name="name"
                        onChange={handleInputChange}
                        value={roleData?.name || ""}
                        size="small"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <TextField
                        disabled
                        label="Contact"
                        name="personal_mobile"
                        onChange={handleInputChange}
                        value={roleData?.personal_mobile || ""}
                        size="small"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <TextField
                        disabled
                        label="Email"
                        name="office_email"
                        onChange={handleInputChange}
                        value={roleData?.office_email || ""}
                        size="small"
                      />
                    </FormControl>
                  </Grid>

                </Grid>
                <Grid pt={2.5} container rowSpacing={0} columnSpacing={2}
                  sx={
                      isOwner
                        ? { pointerEvents: "none", opacity: 0.9 }
                        : {}
                    }
                >
                <Grid container item xs={12} spacing={1}>
                  <Grid item xs={12}>
                    <Typography variant="h6" fontWeight={700}>
                      Modules & Access
                    </Typography>
                  </Grid>

                  {/* Core HR */}
                  <Grid item xs={12} sm={6} md={4}>
                    <Box
                      sx={{
                        border: "1px solid #E0E0E0",
                        bgcolor: isOwner ? "transparent" : "#FFFFFF",
                        borderRadius: 2,
                        py: 1.5,
                        px: 2.5,
                        height: "100%",
                      }}
                    >
                      <Typography variant="subtitle1" fontWeight={700}>
                        {"Core HR"} {userData?.f_country_code === "IND" && leaveAccess && "& LMS"}
                      </Typography>

                      <Divider sx={{ my: 1 }} />

                      <Stack>
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                disabled
                                name="enable_corehr"
                                checked={roleData?.enable_corehr || false}
                                onChange={handleInputChange}
                              />
                            }
                            label={"Enable Core HR"}
                          />

                        {roleData?.enable_corehr && (
                        <Box
                          sx={{
                            ml: 4,
                            px: 2,
                            border: "1px solid #E6EAF0",
                            bgcolor: "#f4f2f7",
                            borderRadius: 2,
                          }}
                        >
                          <Stack>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  size="small"
                                  disabled={disableEdit}
                                  name="enable_employee_management"
                                  checked={roleData?.enable_employee_management || false}
                                  onChange={handleInputChange}
                                />
                              }
                              label={
                                <LabelWithInfo
                                  label="Enable Employee Management"
                                  tooltip="Allows the user to access and manage employee-related information."
                                />
                              }
                            />
                          </Stack>
                        </Box>)}
                        {userData?.f_country_code === "IND" && leaveAccess && (
                          <>
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                disabled={disableEdit}
                                name="enable_lms"
                                checked={roleData?.enable_lms || false}
                                onChange={handleInputChange}
                              />
                            }
                            label={"Enable LMS"}
                          />
                        {roleData?.enable_lms && (
                        <Box
                          sx={{
                            ml: 4,
                            px: 2,
                            border: "1px solid #E6EAF0",
                            bgcolor: "#f4f2f7",
                            borderRadius: 2,
                          }}
                        >
                          <Stack>
                            <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                disabled={disableEdit}
                                name="enable_lms_executive"
                                checked={roleData?.enable_lms_executive || false}
                                onChange={handleInputChange}
                              />
                            }
                            label={
                              <LabelWithInfo
                                label="Enable LMS Executive Access"
                                tooltip="Allows the user to manage leave requests and attendance for employees within their reporting hierarchy."
                              />
                            }
                          />
                          </Stack>
                        </Box>)}
                      </>
                        )}
                      </Stack>
                    </Box>
                  </Grid>

                  {/* Payroll */}
                  {(checkPayrollAccess() || userData?.workspace_expense_flag) && (

                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          border: "1px solid #E0E0E0",
                          bgcolor: isOwner ? "transparent" : "#FFFFFF",
                          borderRadius: 2,
                          py: 1.5,
                          px: 2.5,
                          height: "100%",
                        }}
                      >
                        <Typography variant="subtitle1" fontWeight={700}>
                          {checkPayrollAccess() ? "Finance & Payroll" : userData?.workspace_expense_flag ? "Finance" : ""}
                        </Typography>
                        <Divider sx={{ my: 1 }} />

                        <Stack>
                         {checkPayrollAccess() &&
                          <>
                            <FormControl
                              error={
                                errors?.enable_payroll &&
                                !roleData?.enable_payroll_executive &&
                                !roleData?.enable_finance_executive
                              }
                              component="fieldset"
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    size="small"
                                    name="enable_payroll"
                                    checked={roleData?.enable_payroll || false}
                                    onChange={handleInputChange}
                                  />
                                }
                                label={
                                  <LabelWithInfo
                                    label="Enable Executive Access for Payroll"
                                    tooltip="Enables access to the core Payroll Management modules."
                                  />
                                }
                              />
                              {errors?.enable_payroll &&
                                !roleData?.enable_payroll_executive &&
                                !roleData?.enable_finance_executive && (
                                  <FormHelperText>
                                    {errors?.enable_payroll}
                                  </FormHelperText>
                                )}
                            </FormControl>

                            {roleData?.enable_payroll && (
                              <Box
                                sx={{
                                  ml: 4,
                                  px: 2,
                                  border: "1px solid #E6EAF0",
                                  bgcolor: "#f4f2f7",
                                  borderRadius: 2,
                                }}
                              >
                                <Stack>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        size="small"
                                        name="enable_payroll_executive"
                                        checked={
                                          roleData?.enable_payroll_executive ||
                                          false
                                        }
                                        onChange={handleInputChange}
                                      />
                                    }
                                    label={
                                      <LabelWithInfo
                                        label="Assign as Payroll Executive"
                                        tooltip="Allows the user to process and manage payroll operations."
                                      />
                                    }
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        size="small"
                                        name="enable_finance_executive"
                                        checked={
                                          roleData?.enable_finance_executive ||
                                          false
                                        }
                                        onChange={handleInputChange}
                                      />
                                    }
                                    label={
                                      <LabelWithInfo
                                        label="Assign as Finance Executive"
                                        tooltip="Allows the user to process and manage payroll operations."
                                      />
                                    }
                                  />
                                </Stack>
                              </Box>
                            )}
                          </>}
                          {userData?.workspace_expense_flag && (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  size="small"
                                  disabled={disableEdit}
                                  name="enable_expense_executive"
                                  checked={
                                    roleData?.enable_expense_executive || false
                                  }
                                  onChange={handleInputChange}
                                />
                              }
                              label={
                                <LabelWithInfo
                                  label="Enable Expense Executive Access"
                                  tooltip="Enables access to Team Expenses."
                                />
                              }
                            />
                          )}
                        </Stack>
                      </Box>
                    </Grid>
                  )}
                  

                  {/* Miscellaneous */}
                  <Grid item xs={12} sm={6} md={4}>
                    <Box
                      sx={{
                        border: "1px solid #E0E0E0",
                        bgcolor: isOwner ? "transparent" : "#FFFFFF",
                        borderRadius: 2,
                        py: 1.5,
                        px: 2.5,
                        height: "100%",
                      }}
                    >
                      <Typography variant="subtitle1" fontWeight={700}>
                        {userData?.enable_ats && userData?.workspace_visitor_management_flag ? "ATS & Visitor Management" : userData?.enable_ats ? "ATS" 
                        : userData?.workspace_visitor_management_flag ? "Visitor Management" :""} 
                      </Typography>

                      <Divider sx={{ my: 1 }} />

                      <Stack>
                        {userData?.enable_ats && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                disabled={disableEdit}
                                name="enable_ats"
                                checked={roleData?.enable_ats || false}
                                onChange={handleInputChange}
                              />
                            }
                            label="Enable ATS"
                          />
                        )}

                        {/* // Admins Restrictions */}
                        {["Admin"].includes(roleData?.core_hr_user_type) && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                disabled={disableEdit}
                                name="enable_settings_access"
                                checked={
                                  roleData?.enable_settings_access || false
                                }
                                onChange={handleInputChange}
                              />
                            }
                            label={"Enable Settings"}
                          />
                        )}
                        {userData?.workspace_visitor_management_flag && (
                          <>
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                disabled={disableEdit}
                                name="enable_visitor_management"
                                checked={
                                  roleData?.enable_visitor_management || false
                                }
                                onChange={handleInputChange}
                              />
                            }
                            label={
                              <LabelWithInfo
                                label="Enable Visitor Management"
                                tooltip="Enables access to the core Visitor Management modules, including Pre-registration and Visitor Entry."
                              />
                            }
                          />
                          {roleData?.enable_visitor_management && (
                            <Box
                              sx={{
                                ml: 4,
                                px: 2,
                                border: "1px solid #E6EAF0",
                                bgcolor: "#f4f2f7",
                                borderRadius: 2,
                              }}
                            >
                              <Stack> 
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      name="vm_exec_access"
                                      checked={
                                        roleData?.vm_exec_access ||
                                        false
                                      }
                                      onChange={handleInputChange}
                                    />
                                  }
                                  label={
                                    <LabelWithInfo
                                      label={"Enable Visitor Executive Access"}
                                      tooltip="Enables additional access to Dashboard and Report along with Pre-registration and Visitor Entry."
                                    />
                                  }
                                />
                              </Stack>
                            </Box>
                          )}
                          </>
                        )}
                      </Stack>
                    </Box>
                  </Grid>

                  {/* Controls */}
                  <Grid item xs={12} sm={6} md={4}>
                    <Box
                      sx={{
                        border: "1px solid #E0E0E0",
                        bgcolor: isOwner ? "transparent" : "#FFFFFF",
                        borderRadius: 2,
                        py: 1.5,
                        px: 2.5,
                        height: "100%",
                      }}
                    >
                      <Typography variant="subtitle1" fontWeight={700}>
                        Controls & Restrictions
                      </Typography>

                      <Divider sx={{ my: 1 }} />
                      <Stack>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              disabled={disableEdit}
                              name="all_locations_access"
                              checked={
                                roleData?.all_locations_access || false
                              }
                              onChange={handleInputChange}
                            />
                          }
                          label={
                            <LabelWithInfo
                              label="Enable Location Restriction"
                              tooltip="When enabled, access to selected modules (such as My Employee, Attendance and Payroll) is restricted to approved locations only."
                            />
                          }
                        />
                        {roleData?.all_locations_access && (
                          <Box
                            sx={{
                              ml: 4,
                              px: 2,
                              border: "1px solid #E6EAF0",
                              bgcolor: "#f4f2f7",
                              borderRadius: 2,
                            }}
                          >
                            <Stack>
                              <FormControl
                                fullWidth
                                error={Boolean(errors.ats_work_location_id)}
                                sx={{ my: 1 }}
                              >
                                <SelectableMultiSelect
                                  multiple
                                  label="Work Location Access"
                                  placeholder="Select Location"
                                  value={roleData?.ats_work_location_id}
                                  loading={handleWorkLoacation}
                                  fieldLabel="work_location_name"
                                  name="ats_work_location_id"
                                  size="small"
                                  onChangeEvent={handleInputChange}
                                  data={worklocationData}
                                  menuHeight={150} // optional
                                />
                                {errors?.ats_work_location_id && (
                                  <FormHelperText>
                                    {errors?.ats_work_location_id}
                                  </FormHelperText>
                                )}
                              </FormControl>
                              {leaveAccess &&
                                roleData?.all_locations_access &&
                                roleData?.enable_lms && (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        size="small"
                                        disabled={disableEdit}
                                        name="enable_face_location_restriction"
                                        checked={
                                          roleData?.enable_face_location_restriction ||
                                          false
                                        }
                                        onChange={handleInputChange}
                                      />
                                    }
                                    label={
                                      <LabelWithInfo
                                        label="Enable Face Attendance Location Restriction"
                                        tooltip="When enabled, face attendance can be marked only from the configured work location. This setting is independent of general location restrictions."
                                      />
                                    }
                                  />
                                )}
                            </Stack>
                          </Box>
                        )}
                        {leaveAccess && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                disabled={disableEdit}
                                name="enable_geofencing"
                                checked={roleData?.enable_geofencing || false}
                                onChange={handleInputChange}
                              />
                            }
                            label={
                              <LabelWithInfo
                                label="Enable Geofencing"
                                tooltip="When enabled, employees can mark attendance only from the defined work location within the configured radius (in meters)."
                              />
                            }
                          />
                        )}
                      </Stack>
                    </Box>
                  </Grid>
                </Grid>
                </Grid>
                <Grid item xs={12} mt={2}>
                  <Box sx={{ display: "flex", alignItems: "start", gap: 1 }}>
                    <InfoOutlinedIcon color="primary" fontSize="small" />
                      <Typography variant="body2" color="text.secondary">
                        Note:
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Users receive access based on the permissions and executive access options enabled for their role.<br />
                        {leaveAccess && (
                          <>
                            Employees with LMS Executive access can manage only their direct reportees and have access limited to their reporting hierarchy.
                            <br />
                          </>
                        )}
                        Enable Location Restriction: When enabled, access to selected modules (such as My Employee, Attendance and Payroll) is restricted to approved locations only.<br />
                        {leaveAccess && (
                          <>
                            Enable Face Attendance Location Restriction: When enabled, face attendance can be marked only from the configured work location. This setting is independent of general location restrictions.<br />
                            Enable Geofencing: When enabled, employees can mark attendance only from the defined work location within the configured radius (in meters).<br />
                          </>
                        )}
                      </Typography>
                  </Box>
                </Grid>
              </Paper>
            </Grid>
        </Box>
  );
}

const LabelWithInfo = ({ label, tooltip }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
    <Typography variant="body1" color="inherit">{label}</Typography>

    {tooltip && (
      <Tooltip title={tooltip} arrow placement="top">
        <InfoOutlinedIcon
          fontSize="inherit"
          color="action"
          sx={{ cursor: "pointer", fontSize: 16 }}
        />
      </Tooltip>)}
  </Box>
);